import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { TerminalExternalIdResponse } from '@/repositories/generated';

const response: TerminalExternalIdResponse[] = [
  {
    externalId: 'terminal001',
  },
  {
    externalId: 'terminal002',
  },
  {
    externalId: 'terminal003',
  },
];

export const autocompleteExternalTerminalId = http.get(
  createMockEndpoint('/autocomplete/terminal/externalId'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
